import { render, staticRenderFns } from "./BolFactura.vue?vue&type=template&id=4912e492"
import script from "./BolFactura.vue?vue&type=script&lang=js"
export * from "./BolFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/BolFactura.vue
// module id = null
// module chunks = 